//CRN_20260508 - Riskline Advisories service (PUSH side - reads from SureSim backend)
//CRN_20260513 - https://riskline.readme.io/reference/apis-overview

import { AdvisoryDTO, AdvisoryFilterDTO, AdvisoryPagedResultDTO } from '../../models/system/riskline/riskline-advisory.dto';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { eSimApiPaths } from '../../consts';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../utelize/general/exceptions-service';
import { HttpClientService } from '../utelize/general/http-client-service';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RisklineAdvisoriesService {

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getAdvisories(filter?: AdvisoryFilterDTO): Observable<AdvisoryDTO[]> {
    try {
      return this.getAdvisoriesPaged(filter)
                 .pipe(map(result => result?.items ?? []));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of([]);
    }
  }

  public getAdvisoriesPaged(filter?: AdvisoryFilterDTO): Observable<AdvisoryPagedResultDTO> {
    try {
      let params=new HttpParams();

      if (filter?.activeOnly!=null)
        params=params.set('activeOnly', filter.activeOnly.toString());

      if (filter?.countryIsoCode)
        params=params.set('countryIsoCode', filter.countryIsoCode);

      if (filter?.pageIndex!=null)
        params=params.set('pageIndex', filter.pageIndex.toString());

      if (filter?.pageSize!=null)
        params=params.set('pageSize', filter.pageSize.toString());

      if (filter?.riskLevelIds?.length)
        filter.riskLevelIds.forEach(id => { params=params.append('riskLevelIds', id.toString()); });

      return this.httpClientService
             .get<AdvisoryPagedResultDTO>(environment.eSimApi +
                                          eSimApiPaths.RiskIntelligence + '/' +
                                          eSimApiPaths.RiskIntelligenceAdvisories,
                                          { params: params })
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklineAdvisoriesService.getAdvisoriesPaged() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of({ items: [], pageIndex: 0, pageSize: 0, totalCount: 0 });
    }
  }

  public getAdvisoriesForCountry(isoCode: string): Observable<AdvisoryDTO[]> {
    try {
      if (!isoCode || isoCode.trim()=='')
        throw new Error('RisklineAdvisoriesService.getAdvisoriesForCountry() - isoCode is required');

      return this.getAdvisories({ activeOnly: true, countryIsoCode: isoCode });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of([]);
    }
  }

  public getAdvisoryById(id: string): Observable<AdvisoryDTO> {
    try {
      if (!id || id.trim()=='')
        throw new Error('RisklineAdvisoriesService.getAdvisoryById() - id is required');

      return this.httpClientService
             .get<AdvisoryDTO>(environment.eSimApi +
                               eSimApiPaths.RiskIntelligence + '/' +
                               eSimApiPaths.RiskIntelligenceAdvisories +
                               '/' + id)
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklineAdvisoriesService.getAdvisoryById() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
